export function getVersicherteGegeText(gegenstaende: Array<string>): string {
  let risiko = '';
  let index = 0;
  const kategorien = gegenstaende.reduce<Record<string, number>>((object, gegenstand) => {
    object[gegenstand] = (object[gegenstand] || 0) + 1;
    return object;
  }, {});

  for (const kategorie in kategorien) {
    if (index < 3) {
      const anzahl = kategorien[kategorie];
      risiko += anzahl === 1 ? kategorie + '<br>' : kategorie + ' (' + anzahl + ' Stk.)<br>';
      index++;
    } else {
      risiko += 'Weitere Gegenstände';
      break;
    }
  }
  return risiko.endsWith('<br>') ? risiko.slice(0, -4) : risiko;
}
